const labelsThatLackContext = [
  'learn more',
  'read more',
  'read this',
  'see details',
];

export const labelLacksContext = label => typeof label === 'string' && labelsThatLackContext.includes(label.toLowerCase());
